import { useEffect, useRef, useCallback } from 'react'
import { useRouter } from 'next/router'
import { useAppDispatch, useAppSelector } from '@/redux/hooks'
import { setPreviousPage } from '@/redux/reducers/common'
import { ROUTE_PATH } from '@/constants/routePath'
import { envConfigs } from '@/constants/config'

const EXCLUDED_PREVIOUS_PATHS = [ROUTE_PATH.SAVE_LOCAL_INFORMATION]

const usePreviousRoute = () => {
  const router = useRouter()
  const dispatch = useAppDispatch()
  const previousPathRef = useRef<string | null>(null)
  const { previousPage } = useAppSelector((state) => state.common)

  const handleRouteChangeStart = useCallback(() => {
    previousPathRef.current = router.asPath
  }, [router.asPath])

  const handleRouteChange = useCallback(
    (url: string) => {
      // 防呆：若 previousPathRef.current 尚未設定則不處理
      if (!previousPathRef.current) return
      let prevUrl: URL
      try {
        prevUrl = new URL(previousPathRef.current, envConfigs.domainUrl)
      } catch (e) {
        // 若 URL 解析失敗則不處理
        return
      }
      const prevPath = prevUrl.pathname
      // 集中管理例外路徑
      if (!EXCLUDED_PREVIOUS_PATHS.includes(prevPath)) {
        dispatch(setPreviousPage({ currentPage: url }))
      }
    },
    [dispatch],
  )

  useEffect(() => {
    if (!router?.events) return
    router.events.on('routeChangeStart', handleRouteChangeStart)
    router.events.on('routeChangeComplete', handleRouteChange)
    return () => {
      router.events.off('routeChangeStart', handleRouteChangeStart)
      router.events.off('routeChangeComplete', handleRouteChange)
    }
  }, [])

  return previousPage
}
export default usePreviousRoute
